// What the AI panel's devcontainer picker shows for a NEW chat (U.15): the user's own pick, else the Default Devcontainer, and nothing for a
// chat that is already active (an active chat is bound to the container it started on, U.17; the locked picker shows that one).
export const pickerDevcontainer = (args: {
  picked: string | null;
  defaultId: string | null;
  hasActiveSession: boolean;
}): string | null => args.picked ?? (args.hasActiveSession ? null : args.defaultId);
